// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@vanmeter/MobiusOverrides/Tooltip/Tooltip";
import { fontConfig } from "@vanmeter/XDL/constants";
import HelpCircle from "@vanmeter/XDL/Icons/IconHelpCircle";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            triggerWrapper: {
                css: css`
                    display: inline-block;
                    height: fit-content;
                    width: fit-content;
                    margin-left: 4px;
                    span {
                        display: flex;
                    }
                `,
            },
        },
        iconProps: {
            src: HelpCircle,
            width: 12,
            height: 13,
            color: "common.ui8",
            css: css`
                &:hover {
                    color: ${color("common.ui19")};
                    cursor: pointer;
                }
            `,
        },
        typographyProps: {
            ...fontConfig.xSmallSingleLine,
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
